import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const QRCodeGenerator = ({ url }) => {
  return (
    <div>
      <QRCodeCanvas value={url} />
    </div>
  );
};

export default QRCodeGenerator;
